<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Belépés</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Email">
          <b-input type="email" v-model="email" required />
        </b-field>
        <b-field label="Jelszó">
          <b-input type="password" password-reveal required v-model="password" />
        </b-field>
        <button class="button" type="button" @click="send">Belépés</button>
      </section>
    </div>
  </form>
</template>

<script>
import DictSvc from '@/services.js'
export default {
  name: 'Login',
  props: {
  },
  data: function() {
      return {
        email: '',
        password: '',
        warning: ''
      }
  },
  methods: {
    send: function() {
      if ((this.email != '') && (this.password != '')) {
        DictSvc.login(this.email, this.password)
      }
    }
  }
}
</script>

<style scoped>
</style>
